export enum Role {
  MASTER = 'master',
  SUPERUSER = 'superuser',
  EDITAR_PROJETO = 'editar-projeto',
  EDITAR_REPOSITORIO = 'editar-repositorio',
  FORESTOKEN = 'forestoken',
}

export type AppRoles = Role[];
